export default function createKmlWorker() {
    return new Worker(new URL('../workers/kml.worker.js', import.meta.url));
}
